/** 右ペインの開閉判定に使う、チャットストアの値。 */
export interface RightPaneSignals {
	openFileCount: number;
	fileOpenRequestVersion: number;
}

export type RightPaneAction = "collapse" | "expand" | null;

/** 右ペインの開閉判定に使う、利用者の操作・設定。 */
export interface RightPaneMode {
	/** ファイルを開いたままドラッグで閉じたか。タブの復元 (チャット切り替え) では開き直さない。 */
	userCollapsed: boolean;
	/** 右ペインをピン留めしているか。ピン留め中はファイルがなくなっても閉じない。 */
	pinned: boolean;
}

/** 空の右ペインを閉じておくべきかの判定に使う値。 */
export interface EmptyPaneState {
	openFileCount: number;
	/** リロード直後の URL のタブ復元を待っているか。 */
	restorePending: boolean;
	pinned: boolean;
}

/** ファイルがなく、復元待ちでもピン留めでもなければ、右ペインは閉じておく。 */
export function shouldCollapseEmptyPane({
	openFileCount,
	restorePending,
	pinned,
}: EmptyPaneState): boolean {
	return openFileCount === 0 && !restorePending && !pinned;
}

/**
 * ストア更新 1 回分で右ペインをどうするかを決める。開閉は変化の瞬間だけ行い、
 * ドラッグで開閉した状態を無関係な更新で上書きしない。
 *
 * Args:
 *   prev: 更新前の値。
 *   next: 更新後の値。
 *   mode: 利用者の操作・設定。
 */
export function decideRightPaneAction(
	prev: RightPaneSignals,
	next: RightPaneSignals,
	{ userCollapsed, pinned }: RightPaneMode,
): RightPaneAction {
	if (next.openFileCount === 0) {
		return prev.openFileCount > 0 && !pinned ? "collapse" : null;
	}
	if (next.fileOpenRequestVersion !== prev.fileOpenRequestVersion) return "expand";
	if (next.openFileCount > prev.openFileCount && !userCollapsed) return "expand";
	return null;
}
